import { FeatureGroup } from "../constants/permission";

export default class AuthUtils {
    /**
     * name
     */
    public static hasDocumentPermission(permission: number[]): boolean {
        return permission.includes(FeatureGroup.CREATE_SIDE_DOCUMENT) || permission.includes(FeatureGroup.RECEIVE_SIDE_DOCUMENT);
    }
} 
